import { getCurrentInstallationId, getLastInstallationId } from './currentInstallation';

export function getAuthHeaders() {
  const token = localStorage.getItem('jwt');
  const installationId = getCurrentInstallationId() || getLastInstallationId();

  if (!token) {
    return {};
  }

  return {
    Authorization: `Bearer ${token}`,
    ...(installationId ? { 'x-installation-id': installationId } : {}),
  };
}
